/*
Copyright 2022 by Herbert Potechius,
Ernst-Abbe-Hochschule Jena - University of Applied Sciences - Department of Electrical Engineering and Information
Technology - Immersive Media and AR/VR Research Group.
All rights reserved.
This file is released under the "MIT License Agreement".
Please see the LICENSE file that should have been included as part of this package.
*/

import React from 'react';
import './LightmeshloadButton.scss';
import Images from 'constants/Images';
import Texts from 'constants/Texts';
import SystemConfiguration from "settings/SystemConfiguration"
import Mesh from "rendering/Mesh"
import $ from "jquery"
import * as THREE from "three";

class LightmeshloadButton extends React.Component {
    constructor(props) {
      super(props);
      this.state = {render: true, disabled: false};
    }

    // changeSize = (event) => {
    //   var ele = document.getElementById(this.props.id)
    //   var pos = (document.documentElement.clientWidth / 2 / 3 / 5 * this.props.pos).toString() + "px"
    //   ele.style.setProperty("left", pos);
    // };

    componentDidMount() {
      // var ele = document.getElementById(this.props.id)
      // var pos = (document.documentElement.clientWidth / 2 / 3 / 5 * this.props.pos).toString() + "px"
      // ele.style.setProperty("left", pos);

      // window.addEventListener('resize', (event) => {
      //   this.changeSize()
      // });
    }


    handleClick(version) {
      if(this.state.disabled)
        return

      SystemConfiguration.active_time = version

      try {
        if (SystemConfiguration.active_type == "shading" || SystemConfiguration.active_type == "texture"){
          var new_tex = new THREE.TextureLoader().load(process.env.PUBLIC_URL + '/data/meshes/' + SystemConfiguration.mesh_name + '/' + SystemConfiguration.mesh_name + '_' + SystemConfiguration.active_type +'_'+version+'.jpg')
          SystemConfiguration.material.map = new_tex
          // encoding is set to 3000 which makes the visible brighter
          // set it to 3001 for correct brightness
          SystemConfiguration.material.map.encoding = 3001
          SystemConfiguration.material.map_temp = new_tex
          SystemConfiguration.material.map_temp.encoding = 3001
          SystemConfiguration.material.needsUpdate = true
          console.log(SystemConfiguration.mesh.material)
        } 
      }catch (error) {
          console.log(error)
      }

      // try {
      //   if(SystemConfiguration.active_type == "shading" || SystemConfiguration.active_type == "texture") {
      //     var f_name = "data/meshes/" + SystemConfiguration.mesh_name + "/" + SystemConfiguration.mesh_name + "_" + SystemConfiguration.active_type + "_" + version

      //     SystemConfiguration.mesh_out = <Mesh file_name={f_name}></Mesh>  
      //     $("#rightpanel_header").html(SystemConfiguration.mesh_name).css("color", "black")
      //   }

      // } catch (error) {
      //   console.log(error)
      // }
    }

    render() {
        return (
            <div className={this.props.className} title={this.props.load} style={{ backgroundColor: this.props.color }} onClick={() => this.handleClick(this.props.load)}>{this.props.label}</div>
        );
    }
  }

export default LightmeshloadButton;